import React from 'react'
import './PlayersAndScores.css';

export default function PlayersAndScores({players}) {
  return (
    <div>
      {players.map((player) => {
        let color=player.color;
        return (
          <div className="PlayersAndScores">
          <div key={player.id} style={{color}} className="Player">{player.name}</div>
          <div className="Score">{player.score} </div>
          </div>
        );
      })}
    </div>
  );
}